import {Welcome,  Presentation} from "../components/home/HomeDisplay";
/**
 * Screen for the Home page. 
 */

export default function Home() {



    return (
        <>
      
        <Welcome/>
        <Presentation/>
 
        </>
    )
}